import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gg-chevron-down-icon',
  templateUrl: './chevron-down-icon.component.html',
  styleUrls: ['./chevron-down-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChevronDownIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
